import { connect } from 'react-redux';
import MsDynamicsConfigurationView from './MsDynamicsConfigurationView.jsx';
import { syncOpportunityFields, fetchOpportunityFields, saveOpportunityFields, 
  deleteCustomFields, fetchCustomFields } from 'src/legacy/redux/actions/integrations.jsx';
import { updateConfiguration, deactivateMsDynamicsIntegration } from 'src/legacy/redux/actions/integrations/msDynamics.jsx';

const mapStateToProps = (state, ownProps) => {
  return {
    authenticating:state.legacyRootReducer.settings.integrations.msDynamics.authentication.authenticating,
    errors: state.legacyRootReducer.settings.integrations.msDynamics.changes.error,
    updating: state.legacyRootReducer.settings.integrations.msDynamics.changes.saving,
    loading: state.legacyRootReducer.settings.integrations.msDynamics.changes.loading,
    user: state.users.me,
    opportunityFields: state.legacyRootReducer.settings.integrations.activated.opportunityFields.items,
    customFields: state.legacyRootReducer.settings.integrations.activated.customFields.items,
    loadingFields: state.legacyRootReducer.settings.integrations.activated.opportunityFields.loading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateConfiguration: (configuration) => {
      return dispatch(updateConfiguration(configuration));
    },
    deactivateMsDynamicsIntegration: (type) =>{
      return dispatch(deactivateMsDynamicsIntegration(type));
    },
    syncOpportunityFields: (id) => {
      return dispatch(syncOpportunityFields(id));
    },
    fetchOpportunityFields: (id, filters) => {
      return dispatch(fetchOpportunityFields(id, filters));
    },
    fetchCustomFields: (id) => {
      return dispatch(fetchCustomFields(id));
    },
    saveOpportunityFields: (id, fields) => {
      return dispatch(saveOpportunityFields(id, fields));
    },
    deleteCustomFields: (id, customFieldIds) => {
      return dispatch(deleteCustomFields(id, customFieldIds));
    },
  }
}

const MsDynamicsConfigurationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(MsDynamicsConfigurationView);

export default MsDynamicsConfigurationPage;
